/**
 * @typedef {Object} ValueWithUnit
 * @property {number} value - The numeric value.
 * @property {string} unit - The unit of measurement.
 * @property {string} read - The human-readable representation.
 */

import { DATE_FORMAT } from "constants/dateFormat";
import moment from "moment";

/**
 * @typedef {Object} IndicesDataDtoResponse
 * @property {Object.<string, ValueWithUnit>} [date] - Dynamic keys representing indices data with their values.
 */

/**
 * @typedef {Object} IndicesStatisticsDtoResponse
 * @property {'done' | 'processing'} status - The status of the data retrieval.
 * @property {IndicesDataDtoResponse} data - Dynamic keys representing indices data with their values.
 */

export class IndicesStatisticsDto {
  /**
   *
   * @param {any} data
   * @param {string} startDate
   * @param {string} endDate
   * @returns {IndicesStatisticsDtoResponse}
   */
  static fromApi(data, startDate, endDate) {
    const { status, timeseries } = data || {};

    if (!timeseries) return {};

    const result = {};

    // populate result with dates as keys from startDate to endDate in format YYYY-MM-DD
    const start = moment(startDate);
    const end = moment(endDate);
    for (let m = start.clone(); m.isSameOrBefore(end); m.add(1, "days")) {
      const dateKey = m.format(DATE_FORMAT);
      result[dateKey] = { value: null, read: "" };
    }

    // Iterate through each index (ndmi, ndvi, etc.)
    Object.keys(timeseries).forEach((indexName) => {
      const timeseriesData = timeseries[indexName];

      // For each date entry in the timeseries
      timeseriesData.forEach((entry) => {
        const { date, mean } = entry;

        // Store the min, mean, max for this index on this date
        result[date][indexName] = {
          value: mean,
          read: indexName,
        };
      });
    });

    return {
      status,
      data: result,
    };
  }
}
